export { default } from "../inventory/[slug]";
